import { useEffect, useState } from "react";
import { doc, getDoc, getFirestore } from "firebase/firestore";

/**
 * The event's own theme, from `theme` on its event_timing document — e.g.
 * "aquafitx". An event with a theme gets its own display board and start list;
 * everything else gets the generic pages. Returns null while loading, then the
 * theme name or "default".
 */
export const useEventTheme = (eventId) => {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    if (!eventId) return undefined;
    let isActive = true;
    // Read from Firestore, not the API: the backend may be asleep in standby.
    getDoc(doc(getFirestore(), "event_timing", eventId))
      .then((snapshot) => isActive && setTheme(snapshot.data()?.theme || "default"))
      .catch(() => isActive && setTheme("default"));
    return () => {
      isActive = false;
    };
  }, [eventId]);

  return theme;
};
